import * as React from 'react'

export type ButtonVariant = 'primary' | 'secondary' | 'ghost'

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Visual weight of the button. Defaults to `primary` (brand-filled pill). */
  variant?: ButtonVariant;
  /** Optional leading icon (e.g. a Font Awesome `<i>`), rendered before the label. */
  icon?: React.ReactNode;
}

/**
 * The shared pill button used across the medialib UI. Styled purely through the
 * design tokens defined by the app shell, so it inherits the current theme
 * automatically. Forwards refs and passes through native button attributes.
 */
export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button (
  { variant = 'primary', icon, className, children, type = 'button', ...rest },
  ref
) {
  const classes = ['mlsg-button', `mlsg-button--${variant}`, className].filter(Boolean).join(' ')
  return (
    <button ref={ref} type={type} className={classes} {...rest}>
      {icon && <span className='mlsg-button__icon'>{icon}</span>}
      {children}
    </button>
  )
})
